export function candidate() {
    let data = JSON.parse(sessionStorage.getItem('userData'))
    // console.log(data.userData);
    let candidateData = {
        "user_id": data.userData.user_id,
        "token": data.userData.token,
        "position_code": 'e7zArHuvGVVGDMQc'
    }
    let BaseURL = 'https://api.bighustledigital.com/index.php/candidates';
    return new Promise((resolve, reject) => {
        fetch(BaseURL, {
            method: 'POST',
            body: JSON.stringify(candidateData)
        })
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}